import * as types from '../../../../../../constants/ActionNameConstants';

// Profile details
export const profileRequest = (payload) => ({
  type: types.GET_PROFILE_REQUEST,
  payload,
});

export const profileSuccess = (payload) => ({
  type: types.GET_PROFILE_SUCCESS,
  payload,
});

export const profileFailure = (error) => ({
  type: types.GET_PROFILE_FAILED,
  error,
});

// State list
export const stateListRequest = (payload) => ({
  type: types.EDIT_STATE_REQUEST,
  payload,
});

export const stateListSuccess = (payload) => ({
  type: types.EDIT_STATE_SUCCESS,
  payload,
});

export const stateListFailure = (error) => ({
  type: types.EDIT_STATE_FAILED,
  error,
});

// Profile update details
export const profileEditRequest = (payload) => ({
  type: types.EDIT_PROFILE_REQUEST,
  payload,
});

export const profileEditSuccess = (payload) => ({
  type: types.EDIT_PROFILE_SUCCESS,
  payload,
});

export const profileEditFailure = (error) => ({
  type: types.EDIT_PROFILE_FAILED,
  error,
});
